import { render } from "./sectionSponsor.vue?vue&type=template&id=f87ec720&scoped=true"
import script from "./sectionSponsor.vue?vue&type=script&lang=js"
export * from "./sectionSponsor.vue?vue&type=script&lang=js"

import "./sectionSponsor.vue?vue&type=style&index=0&id=f87ec720&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f87ec720"]])

export default __exports__